(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["integy-new-arrivals"] && !Shopify.designMode) return;
  try {
    
/* V768.1: accessible, bounded navigation; reinitializes after Shopify editor reloads. */
(function(){
  function init(section){
    if(section.dataset.integyNewReady==='1')return;
    var rail=section.querySelector('[data-integy-new-track]');
    var previous=section.querySelector('[data-integy-new-prev]');
    var next=section.querySelector('[data-integy-new-next]');
    if(!rail||!previous||!next)return;
    section.dataset.integyNewReady='1';
    function update(){
      var remaining=rail.scrollWidth-rail.clientWidth;
      previous.disabled=remaining<=3||rail.scrollLeft<=2;
      next.disabled=remaining<=3||rail.scrollLeft>=remaining-2;
    }
    function move(direction){
      var card=rail.querySelector('.integy-new-arrivals__card');
      var gap=parseFloat(window.getComputedStyle(rail).columnGap)||14;
      var step=card?card.getBoundingClientRect().width+gap:rail.clientWidth;
      var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rail.scrollBy({left:step*direction,behavior:reduced?'auto':'smooth'});
    }
    previous.addEventListener('click',function(){move(-1)});
    next.addEventListener('click',function(){move(1)});
    rail.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    if('ResizeObserver' in window){
      var observer=new ResizeObserver(update);
      observer.observe(rail);
    }
    update();
  }
  function initAll(root){root.querySelectorAll('[data-integy-new]').forEach(init);}
  initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["integy-v768-product-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initialize(section){
    if(section.dataset.integyV768CarouselReady==='1')return;
    var rail=section.querySelector('[data-integy-carousel-track]');
    var prev=section.querySelector('[data-integy-carousel-prev]');
    var next=section.querySelector('[data-integy-carousel-next]');
    if(!rail||!prev||!next){if(prev)prev.disabled=true;if(next)next.disabled=true;return}
    section.dataset.integyV768CarouselReady='1';
    function update(){
      var end=Math.max(0,rail.scrollWidth-rail.clientWidth);
      prev.disabled=end<=3||rail.scrollLeft<=2;
      next.disabled=end<=3||rail.scrollLeft>=end-2;
    }
    function move(direction){
      var card=rail.querySelector('.integy-v768-carousel__card');
      var gap=parseFloat(window.getComputedStyle(rail).columnGap)||14;
      var dx=card?card.getBoundingClientRect().width+gap:rail.clientWidth;
      var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rail.scrollBy({left:dx*direction,behavior:reduce?'auto':'smooth'});
    }
    prev.addEventListener('click',function(){move(-1)});
    next.addEventListener('click',function(){move(1)});
    rail.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    if('ResizeObserver' in window){new ResizeObserver(update).observe(rail)}
    update();
  }
  function init(root){if(root.matches&&root.matches('[data-integy-v768-carousel]'))initialize(root);root.querySelectorAll('[data-integy-v768-carousel]').forEach(initialize)}
  init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();

  } catch(e) { console.error(e); }
})();
})();
